<template>
    <b-row class="match-height">
        <b-col md="4" lg="3" class="mb-50">
            <b-card v-if="card" title="Self Evaluation" :sub-title="card.engagement" class="text-center"
                border-variant="dark">
                <!-- Header -->
                <template #header>
                    <span>
                        {{ timeAgo(card.createdAt) }}
                    </span>
                    <b-badge :variant="getBadgeVariant(card.status)"
                        :class="getBadgeClass(card.status)">
                        {{ card.status }}
                    </b-badge>
                </template>
                <b-card-text>
                    {{ getBodyText(card) }}
                </b-card-text>
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
                    :to="getButtonRoute(card)">
                    {{ getButtonText(card) }}
                </b-button>

                <!-- Footer -->
                <template  v-if="!card.isSubmitted" #footer>
                    <b-progress variant="primary" class="progress-bar-primary" height="1.0rem" show-progress>
                        <b-progress-bar :value="card.progress">
                            <span><strong>{{ card.progress }}%</strong></span>
                        </b-progress-bar>
                    </b-progress>
                </template>
            </b-card>
            <b-card v-else class="position-static py-1">
                <blockquote class="blockquote mb-0">
                    <p>No Self Evaluation available for you at the moment.</p>
                    <footer class="blockquote-footer">
                        <span class="text-secondary h5">
                            Please check back later.
                            <!-- <cite title="Source Title">Source Title</cite> -->
                        </span>
                    </footer>
                </blockquote>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import { BCard, BCardText, BRow, BCol, BButton, BProgress, BProgressBar, BBadge } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { timeAgo } from '../../utils';

export default {
    components: {
        BCard,
        BCardText,
        BRow,
        BCol,
        BButton,
        BProgress,
        BProgressBar,
        BBadge,
    },
    directives: {
        Ripple,
    },
    props: {
        surveyType: {
            type: String,
            required: true
        },
        card: {
            required: true,
        },
    },
    methods: {
        getButtonText(card) {
            if (card.progress === 0) {
                return "Start Evaluation";
            } else if (card.status === 'Pending' && card.progress > 0) {
                return "Continue Evaluation";
            } else if (card.status === 'In review') {
                return "Edit Evaluation";
            } else if (card.status === 'Submitted') {
                return "View Evaluation";
            }
            return "Start Evaluation";
        },
        getBodyText(card) {
            return `Complete your self-evaluation survey.`;
        },
        getBadgeVariant(status) {
            if (status === 'Submitted') {
                return 'success';
            } else if (status === 'In review') {
                return 'info';
            } else {
                return 'warning';
            }
        },
        getBadgeClass(status) {
            if (status === 'Submitted') {
                return 'badge-glow';
            } else {
                return 'badge';
            }
        },
        timeAgo, // Directly use the imported timeAgo function
        getButtonRoute(card) {
            if (card.status === 'Submitted') {
                return { name: 'survey-view', params: { id: card._id } };
            }
            return { name: 'survey-fill', params: { id: card._id } };
        },
    },
};
</script>

<style scoped>
/* Add your scoped styles here */
</style>
